(() => {
  const root = document.querySelector('[data-gd-story]');
  const bar = document.querySelector('[data-gd-story-progress]');
  if (!root || !bar) return;

  const update = () => {
    const rect = root.getBoundingClientRect();
    const total = Math.max(root.offsetHeight - window.innerHeight, 1);
    const scrolled = Math.min(Math.max(-rect.top, 0), total);
    const progress = (scrolled / total) * 100;
    bar.style.width = `${progress}%`;
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
